import { IllegalArgumentError } from 'faro-common-model';
import { toRequiredNamedObject } from './named-object.js';
/**
 * @deprecated use {@link toRequiredNamedObject} instead
 */
export const toSystemDefinedObject = toRequiredNamedObject;
/**
 * @deprecated use {@link toRequiredNamedObject} instead and check for null in the consumer
 */
export function toRequiredSystemDefinedObject(systemDefinedObject) {
    if (systemDefinedObject == null) {
        throw new IllegalArgumentError('SystemDefinedObject is required');
    }
    return toRequiredNamedObject(systemDefinedObject);
}
//# sourceMappingURL=system-defined-object.js.map